import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/static/image/icon/whatsapp.png")